import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-videoCoursesManage",
  "use": "icon-videoCoursesManage-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-videoCoursesManage\"><path d=\"M932.636444 967.111111c-513.308444 0-774.428444-0.056889-783.36-0.227555C81.749333 965.176889 56.888889 937.813333 56.888889 869.034667l5.063111-775.907556c0-64.284444 23.893333-91.591111 87.381333-92.501333 262.826667-0.853333 525.653333-0.853333 788.707556 0 55.580444 0 84.764444 28.273778 85.560889 90.794666 0.512 40.846222 0.568889 302.535111 0.113778 784.952889a91.022222 91.022222 0 0 1-91.022223 90.737778z m-239.331555-433.038222a47.217778 47.217778 0 0 0 20.593778-39.651556 47.217778 47.217778 0 0 0-20.593778-39.651555L479.345778 314.709333a39.253333 39.253333 0 0 0-42.609778-0.568889 47.104 47.104 0 0 0-21.504 40.163556v280.177778c0 16.611556 8.248889 31.971556 21.504 40.163555a39.253333 39.253333 0 0 0 42.609778-0.568889l213.902222-140.060444v0.056889z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/videoCoursesManage.svg
// module id = iy9m
// module chunks = 78